<div ngbDropdown container="body" class="dropdown" *transloco="let t">
  <button
    (click)="$event.stopPropagation()"
    class="btn dropdown-toggle d-inline-flex align-items-center justify-content-center p-0 primary"
    id="context-menu"
    ngbDropdownToggle
    [style.background-color]="backgroundColor"
  >
    <i class="material-symbols-rounded">{{ icon }}</i>
  </button>
  <div id="dropdownContextMenu" class="dropdown-menu" aria-labelledby="context-menu" ngbDropdownMenu>
    <ul>
      <a
        *ngIf="
          menuType !== menuTypeEnum.ATTENDANCE_OVERVIEW &&
          menuType !== menuTypeEnum.ABSENCE &&
          data?.dayOffType !== dayOffTypeEnum.Holiday &&
          !data?.isWithoutClass
        "
        [routerLink]="navToEdit()"
        class="dropdown-item"
        >{{ t('shared/edit') }}</a
      >
      <a *ngIf="canShowChildHistory()" type="button" (click)="openChildHistory($event)" class="dropdown-item">{{
        t('child/historyMenuLink')
      }}</a>
      <a
        *ngIf="(menuType === menuTypeEnum.CHILD || menuType === menuTypeEnum.GROUP) && !data?.isArchived && !data?.isWithoutClass"
        type="button"
        (click)="toggleArchiveEntity($event, data?.id || data?.childId || data?.uuid, true)"
        class="dropdown-item"
        >{{ t('shared/archive') }}</a
      >
      <a
        *ngIf="(menuType === menuTypeEnum.CHILD || menuType === menuTypeEnum.GROUP) && data?.isArchived && !data?.isWithoutClass"
        type="button"
        (click)="toggleArchiveEntity($event, data?.id || data?.childId || data?.uuid, false)"
        class="dropdown-item"
        >{{ t('shared/unarchive') }}</a
      >
      <a
        *ngIf="menuType === menuTypeEnum.GROUP && !data?.isWithoutClass && canTransferWorkplace()"
        type="button"
        (click)="transferGroupToWorkplace($event)"
        class="dropdown-item"
        >{{ t('transfer/changeWorkplace') }}</a
      >
      <a
        *ngIf="menuType === menuTypeEnum.CHILD && canTransferWorkplace()"
        type="button"
        (click)="transferChildToWorkplace($event)"
        class="dropdown-item"
        >{{ t('transfer/changeWorkplaceAndClass') }}</a
      >
      <a *ngIf="menuType === menuTypeEnum.ATTENDANCE_OVERVIEW" (click)="openModal()" class="dropdown-item">{{ t('shared/edit') }}</a>
      <a
        *ngIf="menuType === menuTypeEnum.ANNOUNCEMENT || menuType === menuTypeEnum.GRADEBOOK"
        type="button"
        (click)="removeEntity($event, data?.id)"
        class="dropdown-item"
        >{{ t('shared/remove') }}</a
      >
      <a *ngIf="menuType === menuTypeEnum.USER && !data?.teacher?.isManager()" (click)="removeUser($event)" class="dropdown-item">{{
        t('shared/remove')
      }}</a>
      <a *ngIf="canTransferUserWorkplace()" (click)="transferUserToWorkplace($event)" class="dropdown-item">{{
        t('transfer/changeWorkplace')
      }}</a>
      <a *ngIf="menuType === menuTypeEnum.CLOSE_RELATIVE" (click)="inviteParent()" class="dropdown-item">{{ t('child/inviteParent') }}</a>
      <a *ngIf="menuType === menuTypeEnum.ABSENCE" (click)="removeAbsence()" class="dropdown-item">{{ t('shared/remove') }}</a>
      <a *ngIf="menuType === menuTypeEnum.DAY_OFF" (click)="removeDayOff()" class="dropdown-item">{{ t('shared/remove') }}</a>
    </ul>
  </div>
</div>
